var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalesSolution(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 585,
    height: 312,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "",
    clipRule: "evenodd",
    transform: "matrix(1 0 0 1 0 0)",
    d: "M0 234L0 -0.75L0 -0.75L439.5 -0.75L439.5 -0.75L439.5 234L439.5 234L0 234z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 1.3333 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M3 210L3 210L3 210L96.91275 210L96.91275 210L96.91275 20.41275L96.91275 20.41275L3 20.41275z",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    fill: "none",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M73.36951 34.760986C 73.36951 35.661453 139.4318 36.39142 220.92375 36.39142L220.92375 36.39142L220.92375 36.39142C 302.4157 36.39142 368.478 35.661453 368.478 34.760986L368.478 34.760986L368.478 34.760986C 368.478 33.86052 302.4157 33.130554 220.92375 33.130554L220.92375 33.130554L220.92375 33.130554C 139.4318 33.130554 73.36951 33.86052 73.36951 34.760986",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M89.1195 204.84781C 89.1195 216.03157 98.1855 225.0978 109.36951 225.0978L109.36951 225.0978L109.36951 225.0978L109.36951 225.0978L333.45676 225.0978L333.45676 225.0978L333.45676 225.0978C 344.63998 225.0978 353.70676 216.03157 353.70676 204.84781L353.70676 204.84781L353.70676 204.84781L353.70676 204.84781L353.70676 48.195755L353.70676 48.195755L353.70676 48.195755C 353.70676 46.953003 352.6995 45.945755 351.45676 45.945755L351.45676 45.945755L351.45676 45.945755L351.45676 45.945755L91.3695 45.945755L91.3695 45.945755L91.3695 45.945755C 90.12675 45.945755 89.1195 46.953003 89.1195 48.195755L89.1195 48.195755L89.1195 48.195755L89.1195 48.195755L89.1195 204.84781z",
    stroke: "#4A5568",
    strokeWidth: 1.5,
    fill: "#1A202C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M90 207.71745C 90 216.83011 97.387505 224.21738 106.5 224.21738L106.5 224.21738L106.5 224.21738L106.5 224.21738L336.32623 224.21738L336.32623 224.21738L336.32623 224.21738C 345.43875 224.21738 352.82623 216.83011 352.82623 207.71738L352.82623 207.71738L352.82623 207.71738L352.82623 207.71738L352.82623 52.04326L352.82623 52.04326L352.82623 52.04326L352.82623 52.04326L90 52.04326L90 52.04326L90 52.04326L90 52.04326L90 207.71745z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M95.21775 215.73915L95.21775 215.73915L95.21775 215.73915L346.305 215.73915L346.305 215.73915L346.305 59.217148L346.305 59.217148L95.21775 59.217148z",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M59.674797 216.71738L59.674797 216.71738L59.674797 216.71738L374.6748 216.71738L374.6748 216.71738L374.6748 59.217377L374.6748 59.217377L59.674797 59.217377z",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    fill: "none",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M56.412598 45C 56.412598 45.82875 57.08415 46.5 57.912598 46.5L57.912598 46.5L57.912598 46.5L57.912598 46.5L383.6085 46.5L383.6085 46.5L383.6085 46.5C 384.43646 46.5 385.10852 45.82875 385.10852 45L385.10852 45L385.10852 45L385.10852 45L385.10852 40.63051L385.10852 40.63051L385.10852 40.63051L385.10852 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 45z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "#A3ACB1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M56.412598 45C 56.412598 45.82875 57.08415 46.5 57.912598 46.5L57.912598 46.5L57.912598 46.5L57.912598 46.5L383.6085 46.5L383.6085 46.5L383.6085 46.5C 384.43646 46.5 385.10852 45.82875 385.10852 45L385.10852 45L385.10852 45L385.10852 45L385.10852 40.63051L385.10852 40.63051L385.10852 40.63051L385.10852 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 45z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "none",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L385.10852 40.63051L385.10852 40.63051L385.10852 40.63051C 372.2055 38.028015 359.076 36.717743 345.91348 36.717743L345.91348 36.717743L345.91348 36.717743L345.91348 36.717743L92.0595 36.717743L92.0595 36.717743L92.0595 36.717743C 80.07 36.717743 68.11658 38.029495 56.412598 40.63051z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "#647279",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L56.412598 40.63051L385.10852 40.63051L385.10852 40.63051L385.10852 40.63051C 372.2055 38.028015 359.076 36.717743 345.91348 36.717743L345.91348 36.717743L345.91348 36.717743L345.91348 36.717743L92.0595 36.717743L92.0595 36.717743L92.0595 36.717743C 80.07 36.717743 68.11658 38.029495 56.412598 40.63051z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "none",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M193.70624 46.5C 193.87424 43.950745 195.99524 41.934753 198.58725 41.934753L198.58725 41.934753L198.58725 41.934753L198.58725 41.934753L243.26099 41.934753L243.26099 41.934753L243.26099 41.934753C 245.853 41.934753 247.974 43.950745 248.142 46.5L248.142 46.5L248.142 46.5L248.142 46.5L193.70624 46.5z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "#96A1A8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M193.70624 46.5C 193.87424 43.950745 195.99524 41.934753 198.58725 41.934753L198.58725 41.934753L198.58725 41.934753L198.58725 41.934753L243.26099 41.934753L243.26099 41.934753L243.26099 41.934753C 245.853 41.934753 247.974 43.950745 248.142 46.5L248.142 46.5L248.142 46.5L248.142 46.5L193.70624 46.5z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "none",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 234)",
    d: "M342 234.75L342 234.75L342 234.75L435.91275 234.75L435.91275 234.75L435.91275 45.16275L435.91275 45.16275L342 45.16275z",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    fill: "none",
    strokeOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesSolution);
export default __webpack_public_path__ + "static/media/SalesSolution.50a25847a53303bd0404833ad48b04fc.svg";
export { ForwardRef as ReactComponent };